"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeGenericParcelQuery = exports.getAllParcels = void 0;
const turf = __importStar(require("@turf/turf"));
const arcgis_rest_feature_layer_1 = require("@esri/arcgis-rest-feature-layer");
const core_1 = require("@natomas-org/core");
// This is used to retrieve parcel geometries, regardless of a query limit of 1000 results.
const getAllParcels = async (whereClause, geometry, offset, signal) => {
    var _a, _b, _c;
    if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
        return null;
    }
    let dataToSet = undefined;
    const response = await executeGenericParcelQuery(whereClause, geometry, offset ? offset : 0, signal);
    if (response && ((_a = response === null || response === void 0 ? void 0 : response.features) === null || _a === void 0 ? void 0 : _a.length) > 999) {
        dataToSet = response;
        const newData = await (0, exports.getAllParcels)(whereClause, geometry, offset + 1, signal);
        if (!newData) {
            return null;
        }
        if (newData && ((_b = newData === null || newData === void 0 ? void 0 : newData.features) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            dataToSet.features = [...dataToSet.features, ...newData.features];
        }
    }
    else if (response && ((_c = response === null || response === void 0 ? void 0 : response.features) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        return response;
    }
    else {
        return null;
    }
    return dataToSet;
};
exports.getAllParcels = getAllParcels;
// Returns all parcels within 10km of a geometry point. It determines which state
//  layer to use.
async function executeGenericParcelQuery(whereClause, geometry, offset, signal) {
    var _a, _b, _c, _d, _e, _f;
    const center = geometry;
    const radius = 0.5;
    const options = { steps: 10, units: "kilometers" };
    // @ts-ignore
    const circle = turf.circle(center, radius, options);
    const stateAndCounty = (await (0, arcgis_rest_feature_layer_1.queryFeatures)({
        url: core_1.US_COUNTIES,
        geometry: JSON.stringify({ y: geometry[1], x: geometry[0] }),
        geometryType: "esriGeometryPoint",
        spatialRel: "esriSpatialRelIntersects",
        returnGeometry: false,
        outFields: ["NAME", "STATE_NAME"],
        f: "geojson",
    }));
    const address = {
        city: "",
        country: "",
        full_address: "",
        geohash: undefined,
        latitude: null,
        longitude: null,
        street: "",
        street_number: "",
        zip: "",
        // @ts-ignore
        state: (_c = (_b = (_a = stateAndCounty === null || stateAndCounty === void 0 ? void 0 : stateAndCounty.features[0]) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.STATE_NAME) === null || _c === void 0 ? void 0 : _c.toUpperCase(),
        // @ts-ignore
        county: (_f = (_e = (_d = stateAndCounty === null || stateAndCounty === void 0 ? void 0 : stateAndCounty.features[0]) === null || _d === void 0 ? void 0 : _d.properties) === null || _e === void 0 ? void 0 : _e.NAME) === null || _f === void 0 ? void 0 : _f.toUpperCase(),
    };
    return (0, arcgis_rest_feature_layer_1.queryFeatures)({
        url: (0, core_1.getParcelLayer)(address, true),
        // @ts-ignore
        geometry: JSON.stringify({ rings: circle.geometry.coordinates }),
        geometryType: "esriGeometryPolygon",
        inSR: "4326",
        spatialRel: "esriSpatialRelIntersects",
        resultOffset: offset ? offset * 1000 : 0,
        where: "1=1",
        f: "geojson",
        returnGeometry: true,
        signal: signal,
    })
        .then((response) => {
        return response;
    })
        .catch((e) => {
        console.log(e);
        return null;
    });
}
exports.executeGenericParcelQuery = executeGenericParcelQuery;
//# sourceMappingURL=parcels.js.map